import axios from 'axios';

import { LogService } from '../../services/log-service';

export const PackingRecommendationAction = {
  Applied: 'Applied',
  Dismissed: 'Dismissed',
  Overridden: 'Overridden',
  WarningAcknowledged: 'WarningAcknowledged',
} as const;

type PackingRecommendationActionType = (typeof PackingRecommendationAction)[keyof typeof PackingRecommendationAction];

type PackingRecommendationActivityPayload = {
  fulfillmentPlanId: string;
  action: PackingRecommendationActionType;
  packageName: string;
  overrideReason?: string;
};

export const logPackingRecommendationActivity = (payload: PackingRecommendationActivityPayload): void => {
  if (!payload.fulfillmentPlanId) return;

  axios.post('/fulfillmentplan/packing-recommendation-activity', payload).catch((error: unknown) => {
    LogService.logError(error instanceof Error ? error : new Error(`Failed to log packing recommendation activity: ${String(error)}`));
  });
};
